import React, { useState, useEffect } from 'react';
import {
  getPlatos,
  getCategorias,
  crearPlato,
  actualizarPlato,
  eliminarPlato,
} from '../../services/api';

function Platos() {
  const [platos, setPlatos] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editando, setEditando] = useState(null);
  const [formData, setFormData] = useState({
    nombre: '',
    descripcion: '',
    categoria_id: '',
    imagen_url: '',
  });
  const [mensaje, setMensaje] = useState(null);

  useEffect(() => {
    cargarDatos();
  }, []);

  const cargarDatos = async () => {
    try {
      const [platosRes, categoriasRes] = await Promise.all([
        getPlatos(),
        getCategorias(),
      ]);
      setPlatos(platosRes.data);
      setCategorias(categoriasRes.data);
    } catch (error) {
      console.error('Error cargando datos:', error);
    }
  };

  const abrirModal = (plato = null) => {
    if (plato) {
      setEditando(plato.id);
      setFormData({
        nombre: plato.nombre,
        descripcion: plato.descripcion || '',
        categoria_id: plato.categoria_id,
        imagen_url: plato.imagen_url || '',
      });
    } else {
      setEditando(null);
      setFormData({
        nombre: '',
        descripcion: '',
        categoria_id: categorias[0]?.id || '',
        imagen_url: '',
      });
    }
    setShowModal(true);
  };

  const cerrarModal = () => {
    setShowModal(false);
    setEditando(null);
    setFormData({
      nombre: '',
      descripcion: '',
      categoria_id: '',
      imagen_url: '',
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editando) {
        await actualizarPlato(editando, formData);
        mostrarMensaje('Plato actualizado exitosamente', 'success');
      } else {
        await crearPlato(formData);
        mostrarMensaje('Plato creado exitosamente', 'success');
      }
      cerrarModal();
      cargarDatos();
    } catch (error) {
      console.error('Error guardando plato:', error);
      mostrarMensaje(
        error.response?.data?.error || 'Error al guardar plato',
        'error'
      );
    }
  };

  const handleEliminar = async (id, nombre) => {
    if (!window.confirm(`¿Estás seguro de eliminar "${nombre}"?`)) {
      return;
    }

    try {
      await eliminarPlato(id);
      mostrarMensaje('Plato eliminado exitosamente', 'success');
      cargarDatos();
    } catch (error) {
      console.error('Error eliminando plato:', error);
      mostrarMensaje(
        error.response?.data?.error || 'Error al eliminar plato',
        'error'
      );
    }
  };

  const toggleActivo = async (plato) => {
    try {
      await actualizarPlato(plato.id, { activo: !plato.activo });
      cargarDatos();
    } catch (error) {
      console.error('Error actualizando estado:', error);
    }
  };

  const mostrarMensaje = (texto, tipo) => {
    setMensaje({ texto, tipo });
    setTimeout(() => setMensaje(null), 5000);
  };

  const platosPorCategoria = (categorias || []).map((cat) => ({
    ...cat,
    platos: (platos || []).filter((p) => p.categoria_id === cat.id),
  }));

  return (
    <div>
      <div className="page-header">
        <h1>Gestión de Platos</h1>
        <p>Administra los platos disponibles en el sistema</p>
      </div>

      {mensaje && (
        <div className={`alert alert-${mensaje.tipo}`}>{mensaje.texto}</div>
      )}

      <div style={{ marginBottom: '20px' }}>
        <button className="btn btn-primary" onClick={() => abrirModal()}>
          + Nuevo Plato
        </button>
      </div>

      {platosPorCategoria.map((categoria) => (
        <div key={categoria.id} className="card" style={{ marginBottom: '20px' }}>
          <h2>{categoria.nombre}</h2>
          <table>
            <thead>
              <tr>
                <th>Imagen</th>
                <th>Nombre</th>
                <th>Descripción</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {categoria.platos.length === 0 ? (
                <tr>
                  <td colSpan="5" style={{ textAlign: 'center', color: '#7f8c8d' }}>
                    No hay platos en esta categoría
                  </td>
                </tr>
              ) : (
                categoria.platos.map((plato) => (
                  <tr key={plato.id}>
                    <td>
                      {plato.imagen_url && (
                        <img
                          src={plato.imagen_url}
                          alt={plato.nombre}
                          style={{
                            width: '60px',
                            height: '60px',
                            objectFit: 'cover',
                            borderRadius: '5px',
                          }}
                        />
                      )}
                    </td>
                    <td>{plato.nombre}</td>
                    <td>{plato.descripcion}</td>
                    <td>
                      <button
                        className={`btn ${
                          plato.activo ? 'btn-success' : 'btn-secondary'
                        }`}
                        onClick={() => toggleActivo(plato)}
                        style={{ fontSize: '12px', padding: '5px 10px' }}
                      >
                        {plato.activo ? 'Activo' : 'Inactivo'}
                      </button>
                    </td>
                    <td>
                      <button
                        className="btn btn-primary"
                        onClick={() => abrirModal(plato)}
                        style={{
                          fontSize: '12px',
                          padding: '5px 10px',
                          marginRight: '5px',
                        }}
                      >
                        Editar
                      </button>
                      <button
                        className="btn btn-danger"
                        onClick={() => handleEliminar(plato.id, plato.nombre)}
                        style={{ fontSize: '12px', padding: '5px 10px' }}
                      >
                        Eliminar
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      ))}

      {showModal && (
        <div className="modal-overlay" onClick={cerrarModal}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h2>{editando ? 'Editar Plato' : 'Nuevo Plato'}</h2>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Nombre *</label>
                <input
                  type="text"
                  className="form-control"
                  value={formData.nombre}
                  onChange={(e) =>
                    setFormData({ ...formData, nombre: e.target.value })
                  }
                  required
                />
              </div>

              <div className="form-group">
                <label>Descripción</label>
                <textarea
                  className="form-control"
                  value={formData.descripcion}
                  onChange={(e) =>
                    setFormData({ ...formData, descripcion: e.target.value })
                  }
                  rows="3"
                />
              </div>

              <div className="form-group">
                <label>Categoría *</label>
                <select
                  className="form-control"
                  value={formData.categoria_id}
                  onChange={(e) =>
                    setFormData({ ...formData, categoria_id: e.target.value })
                  }
                  required
                >
                  <option value="">Seleccionar categoría</option>
                  {categorias.map((cat) => (
                    <option key={cat.id} value={cat.id}>
                      {cat.nombre}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>URL de Imagen</label>
                <input
                  type="url"
                  className="form-control"
                  value={formData.imagen_url}
                  onChange={(e) =>
                    setFormData({ ...formData, imagen_url: e.target.value })
                  }
                  placeholder="https://..."
                />
              </div>

              <div className="modal-actions">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={cerrarModal}
                >
                  Cancelar
                </button>
                <button type="submit" className="btn btn-primary">
                  {editando ? 'Actualizar' : 'Crear'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Platos;
